import React from 'react';
import SEO from '../components/SEO/SEO';
import HeroBanner from '../components/HeroBanner/HeroBanner';
import ComingSoonAd from '../components/ComingSoonAd/ComingSoonAd';
import Stories from '../components/Stories/Stories';
const AboutUsPage = () => (
	<React.Fragment>
		<SEO
			title='About Us'
			description='We take care of all your travel health needs, offering a complete range of travel vaccinations, antimalarials and experts advice.'
		/>
		<HeroBanner
			title='About us'
			tagline='DocHQ. Your wellbeing partner.'
			imageAlt='workplace'
			imageSrc='workplace.jpg'
		/>
		<WhoWeAre />
		<ComingSoonAd
			contentTitle='Our Vision'
			contentBody={<Vision />}
			imageAlt='city view with binocular'
			imageSrc='vision.jpg'
			side={'left'}
		/>
		<ComingSoonAd
			contentTitle='Our Mission'
			contentBody={<Mission />}
			imageAlt='Target'
			imageSrc='mission.jpg'
		/>
		<Stories
			title='Our Team'
			transitionInterval={14000}
			stories={[
				{
					position: 'Madhur Srivastava - CEO at DocHQ',
					quote:
						'At DocHQ we want to help people to make informed health choices and inspire them to take control of their health. By providing fast medical support and reliable information we can improve their quality of life.',
					imageSrc: 'madhur.jpg',
				},
				{
					position: 'MD Sridhar Lankey - Medical Director at DocHQ',
					quote:
						'As an experienced GP, I have seen the frustrations of patients struggling to get the help they need. Our technology has allowed us to reach out to more patients, more quickly.',
					imageSrc: 'sridhar.png',
				},
			]}
		/>
		<ComingSoonAd
			generalTitle='Our Awards'
			contentBody={<OurAward />}
			imageAlt='Eastleigh Borough Council'
			imageSrc='eastleigh.png'
			backgroundColor='var(--doc-light-grey)'
		/>
	</React.Fragment>
);

export default AboutUsPage;

const OurAward = () => (
	<React.Fragment>
		<p style={{fontWeight: 'bold'}}>Green Borough and Healthy Community Awards</p>
		<p>Healthy Community Award winner</p>
	</React.Fragment>
);
const Vision = () => (
	<React.Fragment>
		<p>
			At DocHQ, our vision is a global community where all people have equal access to healthcare
			and achieve full potential for health and well-being throughout their life.
		</p>
	</React.Fragment>
);
const WhoWeAre = () => (
	<React.Fragment>
		<div className='who-we-are-container'>
			<h2 className='title'>Who We Are</h2>
			<p className='text'>
				DocHQ is a Health Tech company improving your choices.
				<br />
				We help you connect efficiently to health support and advice whether you are at home, work
				or travelling.
			</p>
		</div>
	</React.Fragment>
);
const Mission = () => (
	<React.Fragment>
		<p className='text'>
			At DocHQ, our mission is to provide global, patient-centered healthcare with scalable and
			secure technologies to enable better health outcomes for everyone.
		</p>
	</React.Fragment>
);


